import { NotesTranslations } from "./types";

export const deTranslations: NotesTranslations = {
    heading: "Notizen",
    noNotes: "Keine Notizen verfügbar",
    turn: "drehen",
    turns: "Drehungen",
    notesType: {
        HANDOVER: "Übergabe",
        BLOOD_ORDER: "Labor-Anforderung",
        NOTE: "Notiz",
        INVESTIGATION_NOTE: "Anforderung",
        DIAGNOSIS: "Diagnose",
        INVESTIGATION_ORDER: "Untersuchungsauftrag",
        TREATMENT_ORDER: "Verordnung einer Maßnahme",
        ADMISSION_FORM: "Aufnahmeformular",
        CONSULTATION_ORDER: "Konsilanfoderung",
        DRUG_PRESCRIPTION: "Medikamentengabe",
        DISCHARGE_FORM: "Entlassungsformular",
        ADDITIONAL_TEST: "Zusätzliche Tests",
    },
    prescribed: "",
    ordered: "",
    priority: "Priorität",
    referral: "Konsil an",
    patient_summary: "Anamnese",
    clinical_question: "Klinische Fragestellung",
    additional_tests_ordered: "Zusätzliche Tests wurden angefordert",
};
